export default {
  getList: {
    method: 'post',
    url: '/ws-admincp/node/type/list?archive=ARCHIVE'
  },
  add: {
    method: 'post',
    url: '/ws-admincp/node/type'
  },
  getDetail: {
    method: 'get',
    url: '/ws-admincp/node/type/ID'
  },
  edit: {
    method: 'put',
    url: '/ws-admincp/node/type/ID'
  },
  delete: {
    method: 'delete',
    url: '/ws-admincp/node/type'
  },
  archive: {
    method: 'delete',
    url: '/ws-admincp/node/type/archive'
  },
  restore: {
    method: 'put',
    url: '/ws-admincp/node/type/restore'
  },
  finds: {
    method: 'get',
    url: '/ws-admincp/node/type/find?key=KEY'
  }
}
